import * as React from 'react';
import merge from 'lodash/merge';
import { ThemeContext } from 'styled-components';

import { VALID_HEADING_LEVELS } from '../Headings/common';

import Text, { ITextProps } from './Text';
import { ITextCommonProps } from './common';

export type VALID_TEXT_SIZES = 'small' | 'medium' | 'large';
type TextComponent = Omit<ITextCommonProps, 'size'> & Omit<ITextProps, 'size'>;

export interface ICoreTextBodyProps extends TextComponent {
  variant?: 'body';
  size?: VALID_TEXT_SIZES;
}

export interface ICoreTextHeroProps extends TextComponent {
  variant?: 'hero';
  size: VALID_TEXT_SIZES;
}

export type CoreProps = ICoreTextBodyProps | ICoreTextHeroProps;

const HERO_SIZES = {
  small: 'h3',
  medium: 'h2',
  large: 'h1',
};

const CoreText: React.FC<CoreProps> = ({ children, size, variant = 'body', ...restProps }) => {
  const { themeTwo: { heading, typography }} = React.useContext(ThemeContext);
  let variantTheming;
  let defaultTheme;
  let variantSize = 'default';
  let theme;

  if (variant === 'body') {
    variantTheming = typography.text[variant];
    defaultTheme = typography.text[variant].default;
    variantSize = !size ? variantSize : size;
    theme = merge({}, defaultTheme, variantTheming[variantSize as VALID_TEXT_SIZES]);
  } else {
    variantTheming = heading.level;
    defaultTheme = heading.default;
    variantSize = !size ? variantSize : HERO_SIZES[size];
    theme = merge({}, defaultTheme, variantTheming[variantSize as VALID_HEADING_LEVELS]);
  }

  return (
    <Text
      {...theme}
      // this removes the paragraph spacing set by the theme
      margin={restProps && restProps.forwardedAs ? '0' : theme.margin}
      {...restProps}
    >
      {children}
    </Text>
  );
};

export default CoreText;
